import { AfterViewInit, Component } from '@angular/core';
import { GetStartedContentResources } from '../../content/resources/get-started.content-resources';
import { LocaleManager } from '../../managers/locale.manager';
import {LocaleEnum} from "../../enums/locale.enum";
import { BaseComponent } from '../../components/base.component';
import { RouteManager } from '../../managers/route.manager';
import { ContentManager } from '../../content/managers/content.manager';
import { Meta, Title } from '@angular/platform-browser';
import { SalaryDividendFormContentResources } from '../../content/resources/salary-dividend-form.content-resources';

@Component({
  selector: 'app-salary-dividend-form',
  templateUrl: './salary-dividend-form.component.html',
  styleUrl: './salary-dividend-form.component.scss',
  standalone: false,
})
export class SalaryDividendFormComponent extends BaseComponent implements AfterViewInit {

  protected readonly SalaryDividendFormContentResources = SalaryDividendFormContentResources;

  constructor(
    localeManager: LocaleManager,
    routeManager: RouteManager,
    contentManager: ContentManager,
    titleService: Title,
    meta: Meta,
  ) {
    super(localeManager,
      routeManager,
      contentManager,
      titleService,
      meta,
      GetStartedContentResources,
    );
  }

  ngAfterViewInit(): void {
    this.loadHubspotForm();
  }

  loadHubspotForm() {
    const locale = this.localeManager.getCurrentLocale();

    // @ts-ignore
    if (typeof hbspt === 'undefined') {
      return;
    }

    switch (locale) {
      case LocaleEnum.French:
      case LocaleEnum.English:
        // @ts-ignore
        hbspt.forms.create({
          region: 'na1',
          portalId: '20373920',
          formId: 'f6211478-b310-48ec-b453-5a83b0818775',
          target: '#salary_dividend_hubspot_form',
        });
        break;
    }
  }
}
